import { useEffect, useState, useCallback } from 'react'
import { device } from './lib/device'
import { api } from './lib/api'
import { isWeChat } from './lib/env'
import type { Me } from './lib/types'
import JoinScreen from './components/JoinScreen'
import MainScreen from './components/MainScreen'
import { ToastProvider } from './components/Toast'
import { FamilyDataProvider } from './hooks/useFamilyData'

type AppState = 'loading' | 'join' | 'main'

export default function App() {
  const [state, setState] = useState<AppState>('loading')
  const [me, setMe] = useState<Me | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    boot()
  }, [])

  async function boot() {
    try {
      if (!isWeChat() && 'serviceWorker' in navigator) {
        navigator.serviceWorker.register('/sw.js').catch(() => {})
      }

      const session = device.init()
      if (!session.token) {
        setState('join')
        return
      }

      const meRes = await api.me()
      if (meRes) {
        setMe(meRes)
        setState('main')
      } else {
        device.clearSession()
        setState('join')
      }
    } catch (e) {
      console.error(e)
      setError(e instanceof Error ? e.message : '加载失败')
      setState('join')
    }
  }

  const onJoined = useCallback((meRes: Me) => {
    setMe(meRes)
    setState('main')
  }, [])

  const onLogout = useCallback(() => {
    device.clearSession()
    setMe(null)
    setState('join')
    try {
      sessionStorage.removeItem('baby-log:cache:v1')
    } catch {}
  }, [])

  if (state === 'loading') {
    return (
      <div className="loading-screen">
        <div className="loading-text">加载中...</div>
      </div>
    )
  }

  if (state === 'join') {
    return (
      <ToastProvider>
        <JoinScreen onJoined={onJoined} initialError={error} />
      </ToastProvider>
    )
  }

  return (
    <ToastProvider>
      <FamilyDataProvider>
        <MainScreen me={me!} setMe={setMe} onLogout={onLogout} />
      </FamilyDataProvider>
    </ToastProvider>
  )
}
